import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CrudImplementation} from '@shared/services/crud-implementation';

@Injectable({
  providedIn: 'root'
})
export class CrudUploadsService extends CrudImplementation {
  protected url = '/v1/admin/uploads';

  createEntity(entityjson: any): Observable<any> {
    // Attach the file
    const formData = new FormData();
    formData.append('file', entityjson.file[0], entityjson.file[0].name);
    delete entityjson.file;
    formData.append('entity', JSON.stringify(entityjson));
    return this.http.post(this.serverRoot + this.url, formData, {observe: 'events', reportProgress: true});
  }
}
